export default "__VITE_ASSET__DDdhe671__"